export enum PokerFeatureFlags {
  PKRHomeGamesEmptyStateSideWall = '2023.Q1.Poker.HomeGames.RighSideBar.POKER-5484',
  PKRHomeGamesGameTilesUnsupported = '2022.Q2.Poker.HomeGames.GameTiles.WEB-10835',
  PKRHomeGamesJoinAndCreatePublicClubs = '2023.Q4.Poker.HomeGames.JoinAndCreatePublicClubs.POKER-9619',
  PKRHomeGamesLightMode = '2022.Q4.Poker.HomeGames.LightMode.POKER-2246',
  PKRHomeGamesLogInvalidSession = '2024.Q3.Poker.HomeGames.LogInvalidSession.POKER-14505',
  PKRHomeGamesNewSideBar = '2022.Q3.Poker.HomeGames.Sidebar.POKER-258',
  PKRHomeGamesOnboardingFirstTime = '2022.Q3.Poker.HomeGames.OBFirstTimeUX.POKER-378',
  PKRHomeGamesPublicClubSearch = '2023.Q1.Poker.HomeGames.BasicSearch.POKER-252',
  PKRHomeGamesPublicClubs = '2022.Q4.Poker.HomeGames.PublicClubs.POKER-1917',
  PKRHomeGamesTheWall = '2022.Q4.Poker.HomeGames.TheWall.POKER-1645',
  PKRHomeGamesVideoChatToggleRedesign = '2022.Q4.Poker.HomeGames.VideoChatToggleRedesign.POKER-2012',
  PKRMultiTableTournamentsMobileComingSoon = '2024.Q2.Poker.WebMTT.MobileComingSoon.POKER-11671',
  PKRMultiTableTournamentsVisibility = '2023.Q4.Poker.WebMTT.Visibility.POKER-8355',
  PKRNavigationActiveTableButton = '2024.Q2.Poker.Navigation.ActiveTableButton.POKER-12473',
  PKRPowerPathHideMoreTab = '2024.Q4.Poker.PowerPath.HideMoreTab.POKER-15554',
  PKRPowerPathHideOverviewPage = '2024.Q3.Poker.PowerPath.HideOverviewPage.POKER-13508',
  PKRPowerPathListViewToggle = '2024.Q3.Poker.PowerPath.ListViewToggle.POKER-13567',
  PKRRegulatoryAuthAgeVerification = '2025.Q1.Poker.WebRegulatory.AuthAgeVerification.POKER-16283',
  PKRSpinAndGoFlashAvailable = '2023.Q4.Poker.WebSAG.FlashAvailable.POKER-9938',
  PKRSpinAndGoHoldemAvailable = '2023.Q4.Poker.WebSAG.HoldemAvailable.POKER-9938',
  PKRSpinAndGoHoldemSixAvailable = '2024.Q4.Poker.WebSAG.HoldemSixAvailable.POKER-15188',
  PKRSpinAndGoMaxHoldemAvailable = '2023.Q4.Poker.WebSAG.MaxHoldemAvailable.POKER-8580',
  PKRSpinAndGoOmahaAvailable = '2023.Q4.Poker.WebSAG.OmahaAvailable.POKER-8580',
  PKRSpinAndGoWatchGamesVisibility = '2023.Q4.Poker.WebSAG.WatchGamesVisibility.POKER-7799'
}
